import initInBlogArea from './InBlogArea';
import initAcademyV2 from './AcademyV2';
import initReferencesBanner from '../Banners/ReferencesBanner';
import initCaseStudyBanner from '../Banners/CaseStudyBanner';
import initNewsletterV3 from './NewsletterV3';

export default () => {
  initInBlogArea();
  initAcademyV2();
  initReferencesBanner();
  initCaseStudyBanner();
  initNewsletterV3();
};
